export enum SuicideScreeningResponseEnum {
  No = "No",
  Yes = "Yes",
  YesAndYes = "YesAndYes",
}
